<template>
  <span
    :style="{
      'background-color': marker.color,
      'color': checkColorIsBlackOrWhite(marker.color)
    }"
    class="tag"
    :class="size">

    <span
      v-html="customDescription || marker.description"></span>

    <a role="button"
       v-if="isDeleted && marker.id"
       class="delete is-small"
       @click.prevent="$emit('delete', marker.id)"></a>
  </span>
</template>

<script>
  import { Style } from '@intelipost-js/secure-providers';

  export default {
    name: 'sc-recon-marker',
    props: {
      marker: {
        type: Object,
        required: true,
      },
      size: {
        type: String,
        default: '',
      },
      customDescription: {
        type: String,
      },
      isDeleted: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      checkColorIsBlackOrWhite(color) {
        return Style.checkColorIsBlackOrWhite(color);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/components/sc-recon-marker/ScReconMarker.vue?742eb719